// import Cookies from 'js-cookie';
import actions from './actions';
import balanceActions from '../balance/actions';
import { DataService } from '../../config/dataService/dataService';
import { setItem, removeItem, removeItemBase64 } from '../../utility/localStorageControl';
import { th } from 'date-fns/locale';

const {
  loginBegin,
  loginSuccess,
  loginErr,
  logoutBegin,
  logoutSuccess,
  logoutErr,
  loggedCheckBegin,
  loggedCheckSuccess,
  loggedCheckErr,
  registerBegin,
  registerSuccess,
  registerErr,
} = actions;

const { setBalance } = balanceActions;

const login = (values, errCallback, successCallback) => {
  return async (dispatch) => {
    dispatch(loginBegin());
    try {
      const response = await DataService.post('/auth/login', values);
      const { status, data: responseData } = response;

      if (['auth/multi-factor-auth-required'].includes(responseData.code)) {
        dispatch(loginErr(responseData.message));
        errCallback(responseData);
        return;
      }

      if ([200].includes(status) && response?.data?.user_data) {
        const { balance, ...userWithoutBalance } = response.data.user_data;

        setItem('user_data', JSON.stringify(userWithoutBalance));
        dispatch(loginSuccess(response.data));
        dispatch(setBalance(balance));
        successCallback();
        return;
      }

      if (response.data.error) {
        dispatch(loginErr(response.data.errors));
        return;
      }

      throw new Error('Login failed!');
    } catch (err) {
      console.error(err);
      // HTTP 401 Unauthorized
      const { data, errors } = err.response || {};
      dispatch(loginErr('Logowanie nie powiodło się'));
      errCallback(err.response.data);
    }
  };
};

const loggedCheck = (values) => {
  return async (dispatch) => {
    dispatch(loggedCheckBegin());
    try {
      const response = await DataService.get('/account', values);
      const { status, data: responseData } = response;

      if ([200].includes(status)) {
        dispatch(loggedCheckSuccess(responseData.data));
      } else {
        dispatch(loggedCheckErr(responseData?.message || responseData?.errors || 'Unkown'));
      }
    } catch (err) {
      dispatch(loggedCheckErr(err));
    }
  };
};

const register = (values, callback) => {
  return async (dispatch) => {
    dispatch(registerBegin());
    try {
      const response = await DataService.post('/auth/register', values);
      if (response.data.errors) {
        callback(response.data.errors);
        dispatch(registerErr('Registration failed!'));
      } else {
        dispatch(registerSuccess());
        callback(null, response.data.message);
      }
    } catch (err) {
      callback(err);
      dispatch(registerErr(err));
    }
  };
};

const logOut = (callback) => {
  return async (dispatch) => {
    dispatch(logoutBegin());
    try {
      const response = await DataService.post('/auth/logout');
      removeItem('access_token');
      removeItem('user_data');
      removeItemBase64('balance');
      dispatch(logoutSuccess(false));
      callback();
    } catch (err) {
      dispatch(logoutErr(err));
    }
  };
};

const verify = (data, callback) => {
  return async (dispatch) => {
    try {
      const response = await DataService.post(`/auth/verify/${data.id}/${data.hash}`);
      callback(response.data);
    } catch (err) {
      console.log('t', err);
      callback(err);
    }
  };
};

const resendVerificiation = (data, callback) => {
  return async (dispatch) => {
    try {
      const response = await DataService.post(`/auth/verify/resend`, data);
      callback(response.data);
    } catch (err) {
      console.log('t', err);
      callback(err);
    }
  };
};

const forgotPassword = (data, callback) => {
  return async (dispatch) => {
    try {
      const response = await DataService.post(`/auth/forgot-password`, data);
      callback(null, response.data);
    } catch (err) {
      console.log('t', err);
      callback(err);
    }
  };
};

const resetPassword = (data, callback) => {
  return async (dispatch) => {
    try {
      const response = await DataService.post(`/auth/reset-password`, data);
      callback(null, response.data);
    } catch (err) {
      console.log('t', err);
      callback(err);
    }
  };
};

export { login, logOut, register, loggedCheck, verify, resendVerificiation, forgotPassword, resetPassword };
